import React from 'react';
import './CoreskillNewContent.css';

function CoreskillNewContent(props) {
    return (
        <>
            <div className="coreskill-container">
                <div className="coreskill-wrap">
                    {/* <h2 className='main-head'>Entry-level - <span className='sub-head'>Shifting gears to multi-speed on the transformational 24 months entry-level learning program</span></h2> */}
                    {/* <h2 className='main-head'><span className='sub-head'>Provide multi-speed, end-to-end continuous learning interventions through a 24-month entry-level immersive program to build career in tech.</span></h2> */}

                    <div className="coreskill-row row1">
                        <div className="coreskill-box">
                            <div class="nav flex-column nav-pills" id="v-pills-TE-tab" role="tablist" aria-orientation="vertical">
                                <button tabIndex={0} class={props.menu2 === 'c_tech' || props.menu2 === 'default' ? "nav-link active" : "nav-link"} id="v-pills-techexpressway-tab" data-bs-toggle="pill" data-bs-target="#v-pills-ai" type="button" role="tab" aria-controls="v-pills-techexpressway" aria-selected="true">Tech Expressway</button>
                                {/* <button class="nav-link" id="v-pills-automation-tab" data-bs-toggle="pill" data-bs-target="#v-pills-automation" type="button" role="tab" aria-controls="v-pills-automation" aria-selected="false">Automation</button> */}
                            </div>
                        </div>
                    </div>
                    <div className="coreskill-row row2">
                        {/* <h2 className='main-head'>Entry-level</h2>
                    <p className='sub-head'>Shifting gears to multi-speed on the transformational 24-months entry-level learning program</p> */}
                        <p className='main-head'><span className='sub-head'>Provide multi-speed, end-to-end continuous learning interventions through a 24-month entry-level immersive program to build career in tech.</span></p>
                        <div className="coreskill-box">
                            <div class="tab-content" >

                                <div class={props.menu2 === 'c_tech' || props.menu2 === 'default' ? "tab-pane fade show active" : "tab-pane fade"} id="v-pills-tech" role="tabpanel" aria-label="v-pills-tech-tab">
                                    <div className="tech-container">
                                        <div className="tech-wrap">
                                            <div className={props.menu3 === "TechExpressway" ? "tech-row highlight-search" : "tech-row"}>
                                                <div className="tech-box">
                                                    {/* <img src="images/Offerings/Techexp-icon.png" alt="Techexp" className='techexp-img' /> */}
                                                    <h3 role="heading" aria-level="2">Tech Expressway</h3>
                                                    <p>An end-to-end, 24-months continuous learning program for entry-level new hires who aspire to build a career in technology.</p>
                                                    <p>
                                                        <a href="mailto:praveen.rajaram; amitabh.p.kannal;"  aria-label="mailto:praveen.rajaram; amitabh.p.kannal" className='left-side-link' target="_blank"><img src="images/Offerings/mail-icon-normal.png" alt="" /></a>
                                                        <a href="https://atci.techexpressway.accenture.com/home" className='right-side-link' target="_blank">Explore More <img src="images/Home/Explore arrow.png" alt="" /></a>
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CoreskillNewContent